<div class="actions-section">
  <button
    type="button"
    class="btn btn-light-cancel button-cancel"
    (click)="onClickBtnCancel()"
  >
    {{ lextranslate.i18n["f2929717-3d73-4a39-8280-d41f768d092b"] }}
  </button>
  <button
    type="button"
    class="btn btn-primary button-add"
    (click)="onClickBtnSave()"
    [disabled]="canDisable"
    *ngIf="canShowSaveBtn"
  >
    <div *ngIf="!loading; else loader">
      <span>{{ btnSaveLabel }}</span>
    </div>
  </button>
</div>

<ng-template #loader>
  <mat-spinner class="loader"></mat-spinner>
</ng-template>
